<div class="opt-panel">

  <!-- Sort (card view only) -->
  @if (!hideSort) {
    <bst-sort-options [colDefs]="sortColDefs.length ? sortColDefs : colDefs" [currentSort]="currentSort" (pick)="chooseSort($event)"></bst-sort-options>
  }

  <!-- Active filters -->
  <div class="opt-section">
    <div class="opt-label">{{ 'filter' | translate:{value: ''} }}</div>
    @if (activeFilters.length) {
      <div class="opt-pills">
        @for (f of activeFilters; track f.key) {
          <span class="opt-pill">
            <button type="button" class="opt-pill-edit" (click)="editFilter(f.key, $event)">{{ f.col.title | translate }}</button>
            <button type="button" class="opt-pill-x" [attr.aria-label]="('remove' | translate) + ' ' + (f.col.title | translate)" (click)="removeFilter(f.key)">×</button>
          </span>
        }
      </div>
    } @else {
      <p class="opt-empty">{{ 'nofilters' | translate }}</p>
    }

    @if (!addingFilter) {
      <button type="button" class="opt-add" (click)="addingFilter = true">＋ {{ 'addfilter' | translate }}</button>
    } @else {
      <div class="opt-picker">
        <input nbInput fullWidth fieldSize="small" [(ngModel)]="columnSearch"
               [placeholder]="'findcolumn' | translate">
        <div class="opt-picker-list">
          @for (c of addableColumns; track c.name) {
            <button type="button" class="kebab-item" (click)="pickFilter(c, $event)">{{ c.title | translate }}</button>
          }
          @if (!addableColumns.length) {
            <p class="opt-empty">{{ 'nocolumns' | translate }}</p>
          }
        </div>
        <button type="button" class="opt-add" (click)="addingFilter = false; columnSearch = ''">{{ 'cancel' | translate }}</button>
      </div>
    }
  </div>

  <!-- Columns (disclosed) -->
  @if (!hideColumns) {
    <div class="opt-section">
      <button type="button" class="opt-disclose" (click)="columnsOpen = !columnsOpen"
              [attr.aria-expanded]="columnsOpen">
        <span>{{ 'columns' | translate }} <span class="opt-disclose-count">· {{ shownCount }} / {{ (columns || []).length }}</span></span>
        <nb-icon [icon]="columnsOpen ? 'chevron-down-outline' : 'chevron-right-outline'"></nb-icon>
      </button>
      @if (columnsOpen) {
        <table class="standard directory opt-columns">
          <thead>
            <tr>
              <th class="button-cell">{{ 'display' | translate }}</th>
              <th>{{ 'name' | translate }}</th>
              @if (!disabled) { <th class="button-cell">{{ 'order' | translate }}</th> }
            </tr>
          </thead>
          <tbody [class.dragging]="this.dragging" cdkDropList (cdkDropListDropped)="this.resort($event.previousIndex, $event.currentIndex)">
            @for (column of columns; track column) {
              <tr cdkDrag [cdkDragLockAxis]="'y'" (cdkDragStarted)="this.dragging = column">
                <td class="button-cell">
                  <nb-checkbox #row [formControl]="column.control" (change)="format()"></nb-checkbox>
                </td>
                <td>{{ column.col.title | translate }}</td>
                @if (!disabled) {
                  <td cdkDragHandle class="button-cell draggable"><nb-icon icon="menu"></nb-icon></td>
                }
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  }

  @if (onExport) {
    <div class="opt-section">
      <button nbButton ghost status="basic" size="small" (click)="onExport(this.formatted)">{{ 'exportcsv' | translate }}</button>
    </div>
  }
</div>
